module.exports = __webpack_public_path__ + "media/images/dispatch_ic-62211404f000e2f474ce87aa6fbfccb7.svg";